import React from 'react';
import styles from './PartnerLogo.module.css';
import BrandLogos from '@components/Sustainability/BrandLogos/BrandLogos';
import { extractColors } from '@utils/utils';
import TextSectionMarkdown from '../TextSectionMarkdown/TextSectionMarkdown';
import DynamicDisclaimer from '../Disclaimer/DynamicDisclaimer';

type Props = {
  section: {
    backgroundColor: string;
    component: string;
    contentType: string;
    contentfulName: string;
    disclaimer: string;
    disclaimerTextColor: string;
    headerTextColor: string;
    sectionHeader: string;
    sectionLinks: string[];
  };
};

export default function PartnerLogo({ section }: Props): JSX.Element {
  return (
    <section
      className={styles['partner-logo']}
      style={{ backgroundColor: extractColors(section.backgroundColor) }}
    >
      <TextSectionMarkdown
        textColor={section.headerTextColor}
        backgroundColor={section.backgroundColor}
        markdown={section.sectionHeader}
      />
      <BrandLogos />
      <DynamicDisclaimer
        disclaimerContent={section.disclaimer}
        backgroundColor={extractColors(section.backgroundColor)}
        textColor={extractColors(section.disclaimerTextColor)}
      />
    </section>
  );
}
